import {
    populateTableWidthData,
    pupulateModalSelectVersions,
    addselectedVersionToCompare
} from './iframe';
 
window.populateTableWidthData = populateTableWidthData;
window.pupulateModalSelectVersions = pupulateModalSelectVersions;
window.addselectedVersionToCompare = addselectedVersionToCompare;